import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {
	constructor(
		private toastrService: ToastrService,
		private translateService: TranslateService
	) { }

	public showSuccess(
		message: string,
		title: string = this.translateService.instant('NOTIFICATION.SUCCESS'),
		timeOutInSeconds: number = 3
	) {
		try {
			return this.toastrService.success(message, title, { timeOut: timeOutInSeconds * 1000 });
		} catch (error) {
			console.log(error);
			return null;
		}
	}

	public showInfo(
		message: string,
		title: string = this.translateService.instant('NOTIFICATION.INFO'),
		timeOutInSeconds: number = 5
	) {
		try {
			return this.toastrService.info(message, title, { timeOut: timeOutInSeconds * 1000 });
		} catch (error) {
			console.log(error);
			return null;
		}
	}

	public showWarning(
		message: string,
		title: string = this.translateService.instant('NOTIFICATION.WARNING'),
		timeOutInSeconds: number = 5
	) {
		try {
			return this.toastrService.warning(message, title, { timeOut: timeOutInSeconds * 1000 });
		} catch (error) {
			console.log(error);
			return null;
		}
	}

	public showError(
		message: string,
		title: string = this.translateService.instant('NOTIFICATION.ERROR'),
		timeOutInSeconds: number = 5
	) {
		try {
			return this.toastrService.error(message, title, { timeOut: timeOutInSeconds * 1000 });
		} catch (error) {
			console.log(error);
			return null;
		}
	}

	public clearAll() {
		try {
			this.toastrService.clear();
		} catch (error) {
			console.log(error);
			return null;
		}
	}

	public clear(toast: any) {
		try {
			this.toastrService.clear(toast);
		} catch (error) {
			console.log(error);
			return null;
		}
	}
}
